import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "d-flex align-bottom justify-end flex-column pa-6"
};
import { ref, computed, reactive, watch, onMounted } from 'vue';
const MAX_PAGE_BUTTONS = 6;
export default {
  __name: 'SimplePagination',
  props: {
    perPage: {
      type: Number,
      required: true
    },
    currentPage: {
      type: Number,
      required: true
    },
    totalItems: {
      type: Number,
      required: true
    },
    offset: {
      type: Number,
      required: true
    },
    hideShowAll: {
      type: Boolean,
      default: false
    }
  },
  emits: ['pagechanged', 'showAll'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    onMounted(() => {
      if (props.totalItems < 10) {
        simplePaginationState.hideButtons = true;
      } else {
        simplePaginationState.hideButtons = false;
      }
    });
    const simplePaginationState = reactive({
      hideButtons: false
    });
    watch(props, () => {
      if (props.totalItems < 10) {
        simplePaginationState.hideButtons = true;
      } else {
        simplePaginationState.hideButtons = false;
      }
    });
    const isShowAll = ref(false);
    const emits = __emit;
    const totalPages = computed(() => Math.ceil(props.totalItems / props.perPage));
    const visiblePages = ref(totalPages);
    const computedPageRange = computed(() => {
      const total = totalPages.value;
      const current = props.currentPage;
      const middle = Math.ceil(MAX_PAGE_BUTTONS / 2);
      let range = [];
      let start, end;
      if (current <= middle) {
        start = 1;
        end = Math.min(MAX_PAGE_BUTTONS, total);
      } else if (current > total - middle) {
        start = Math.max(total - MAX_PAGE_BUTTONS + 1, 1);
        end = total;
      } else {
        start = current - middle + 1;
        end = current + middle - 1;
      }
      for (let i = start; i <= end; i++) {
        range.push(i);
      }
      if (start > 1) {
        range.unshift('...');
        range.unshift(1);
      }
      if (end < total) {
        range.push('...');
        range.push(total);
      }
      return range;
    });
    const isInFirstPage = computed(() => props.currentPage === 1);
    const isInLastPage = computed(() => props.currentPage === totalPages.value);
    const changePage = page => {
      emits('pagechanged', page, props.perPage);
    };
    const onClickPreviousPage = () => {
      if (props.currentPage > 1) {
        changePage(props.currentPage - 1);
      }
    };
    const onClickNextPage = () => {
      if (props.currentPage < totalPages.value) {
        changePage(props.currentPage + 1);
      }
    };
    const showAllItems = () => {
      isShowAll.value = true;
      visiblePages.value = totalPages.value;
      emits('showAll');
    };
    return (_ctx, _cache) => {
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_btn = _resolveComponent("v-btn");
      const _component_v_btn_toggle = _resolveComponent("v-btn-toggle");
      return !simplePaginationState.hideButtons ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_v_btn_toggle, {
        divided: "",
        variant: "outlined",
        class: "flex justify-end"
      }, {
        default: _withCtx(() => [_withDirectives(_createVNode(_component_v_btn, {
          onClick: onClickPreviousPage,
          disabled: isInFirstPage.value
        }, {
          default: _withCtx(() => [_createVNode(_component_v_icon, null, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [_createTextVNode("mdi-chevron-left", -1)]))]),
            _: 1
          })]),
          _: 1
        }, 8, ["disabled"]), [[_vShow, !isShowAll.value]]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(computedPageRange.value, n => {
          return _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
            key: n,
            disabled: n === __props.currentPage || n === '...',
            onClick: $event => n !== '...' ? changePage(n) : null
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(n), 1)]),
            _: 2
          }, 1032, ["disabled", "onClick"])), [[_vShow, !isShowAll.value]]);
        }), 128)), _withDirectives(_createVNode(_component_v_btn, {
          onClick: onClickNextPage,
          disabled: isInLastPage.value
        }, {
          default: _withCtx(() => [_createVNode(_component_v_icon, null, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode("mdi-chevron-right", -1)]))]),
            _: 1
          })]),
          _: 1
        }, 8, ["disabled"]), [[_vShow, !isShowAll.value]]), _withDirectives(_createVNode(_component_v_btn, {
          onClick: showAllItems
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode(" Show All ", -1)]))]),
          _: 1
        }, 512), [[_vShow, !isShowAll.value && !__props.hideShowAll]])]),
        _: 1
      })])) : _createCommentVNode("", true);
    };
  }
};